import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { KamonaPasscodeWidgetComponent } from '../../../kamona-passcode-widget/kamona-passcode-widget.component';
import { KamonaOtpComponent } from '../../../kamona-otp/kamona-otp.component';

@Component({
    selector: 'app-mobile-kamona-passcode-widget',
    templateUrl: './mobile-kamona-passcode-widget.component.html',
    styleUrls: ['./mobile-kamona-passcode-widget.component.scss'],
})
export class MobileKamonaPasscodeWidgetComponent extends KamonaPasscodeWidgetComponent implements OnInit {
    @ViewChild('kamonaOtp') kamonaOtp: KamonaOtpComponent;
    @Input() minHeightStyle: string;
    constructor() {
        super();
    }

    ngOnInit(): void {}

    handleEnterPasscode({ value, index }) {
        this.kamonaOtp.handleOnKeydownEvent(value, index);
    }

    handleDeletedPasscode({ index }) {
        this.kamonaOtp.handleOnKeydownEvent('', index);
    }
}
